import ReactPaginate from "react-paginate";
import endpoints from "../../config/endpoints";
import { Sidebar } from "../../layouts/Sidebar";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setLoading } from "../../services/reducers/homeSlice";
import restApi from "../../services/restApi";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Part = () => {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 25;
  const endOffset = itemOffset + itemsPerPage;
  let currentItems = data
    .filter((e) => e.title.toLowerCase().includes(query.toLowerCase()))
    .slice(itemOffset, endOffset);
  const pageCount = Math.ceil(data.length / itemsPerPage);
  const deleteItem = async (id: number) => {
    if (confirm("آیا مطمئن هستید؟")) {
      dispatch(setLoading(true));

      const res = await restApi(endpoints.part.index + id, true).delete({});

      if (res.code == 204) {
        Swal.fire({
          title: "موفق",
          text: "نوع کالا با موفقیت حذف شد",
          icon: "success",
          confirmButtonText: "متوجه شدم",
          didClose() {
            fetchData();
          },
        });
      } else {
        Swal.fire({
          title: "ناموفق",
          text: res?.data,
          icon: "error",
          confirmButtonText: "متوجه شدم",
        });
      }

      dispatch(setLoading(false));
    }
  };
  const list = () => {
    const rows = [];

    data.map((attributegroup: any, index) => {
      rows.push(
        <tr className="">
          <td className="svgContainer">
            <i className="eye"></i>
            <i
              className="trash clickable"
              onClick={() => deleteItem(attributegroup.id)}
            ></i>
            <a
              className="edit clickable"
              target="_blank"
              href={`/part/edit/${attributegroup.id}`}
            >
              <i className="edit"></i>
            </a>
          </td>
          <td className="">{attributegroup.createdAt}</td>
          <td className="">{attributegroup.description}</td>
          <td className="">{attributegroup.slug}</td>
          <td className="">{attributegroup.title}</td>
          <td>{++index}</td>
        </tr>,
      );
    });

    return rows;
  };

  const fetchData = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.part.index, true).get();

    if (res.code == 200) {
      setData(res.data);
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <body className="dashboardBody">
        <Sidebar />
        <main className="dashBoardMain">
          <h1 className="dashBoardTitle">لیست نوع کالا ها</h1>
          <div className="searchContainer">
            <span
              className="dashboardHeader clickable"
              onClick={() => navigate("/part/add")}
            >
              <p>افزودن نوع کالا جدید</p>
              <i className="addPlus"></i>
            </span>
            <div className="dashboardseaechBox">
              <i className="dashMagnifierIcon"></i>
              <input
                className="dashSearchInput"
                placeholder="جستجو"
                onChange={(input: any) => setQuery(input.target.value)}
              ></input>
            </div>
          </div>
          <table className="listTable">
            <thead>
              <tr className="firstTR">
                <th>عملیات</th>
                <th>تاریخ ساخت</th>
                <th>توضیحات</th>
                <th>اسلاگ</th>
                <th>عنوان</th>
                <th>ردیف</th>
              </tr>
            </thead>
            <tbody>{list()}</tbody>
          </table>
          <ReactPaginate
            breakLabel="..."
            nextLabel="بعدی >"
            onPageChange={(event) =>
              setItemOffset((event.selected * itemsPerPage) % data.length)
            }
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="< قبلی"
            renderOnZeroPageCount={null}
            className="pagination"
            pageClassName="paginationBreak"
            previousClassName="paginationBreak"
            nextClassName="paginationBreak"
            activeClassName="paginationActive"
          />
        </main>
      </body>
    </>
  );
};
export default Part;
